import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCrhrCdZj1yRM8YH9B4tZDuKOYbyCiATCI",
  authDomain: "myjniamd.firebaseapp.com",
  databaseURL: "https://myjniamd-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "myjniamd",
  storageBucket: "myjniamd.firebasestorage.app",
  messagingSenderId: "330946272940",
  appId: "1:330946272940:web:ca6b2c9f48865684f48909",
  measurementId: "G-NK6CM2DCB3"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
